<div class="wrapper">
    <app-dashboard>
        <p-toast></p-toast>
        <div class="page">
            <div class="top-section">
                <div class="button"><app-button-fill [action]="addApiKey" buttonText="Create API Key"></app-button-fill></div>
            </div>
            <div class="second-section">
                <div class="table">
                    <!-- parent.component.html -->
                    <app-api-table [data]="apiKeys" [remove]="showModal" [processLoading]="fetchingData"></app-api-table>
                    <!-- <app-table [fetchingData]="fetchingData" [headers]="tableHeaders" [data]="tableData" [remove]="showModal" [canDelete]="true"></app-table> -->
        
                </div>
            </div>
        </div>
    </app-dashboard>
</div>

<app-modal [title]="modalTitle" [isOpen]="isModalOpen" (closeModalEvent)="closeModal()">
    <!-- Dynamic content goes here -->
    <div *ngIf="!apiKeyCreated">
        <div class="form-container">
            <p class="form-subheading">Enter the following details to create a new API key.</p>
            <app-error-message [message]="errorMessage"></app-error-message>
              <div class=" full-width">
              <div class="form-holder full-width"><app-input (dataEvent)="newName($event)" label="Name" placeholder="Ameh & Sons"></app-input></div>
              <div class="form-holder full-width"><app-input (dataEvent)="newIpAddress($event)" label="IP Address(es)" placeholder="10.0.3.232, 20.0.5.99, ..."></app-input></div>
              <div class="form-holder half-width"><app-dropdown label="API Key Duration" [options]="durationOptions" [selectedValue]=this.newApiKey.expiresIn (selectionChanged)="onSelectedDuration($event)"></app-dropdown></div>
          </div>
          </div>
          <div class="button"><app-button-fill [processLoading]="isLoading" [action]="createApiKey" buttonText="Add to Configurations"></app-button-fill></div>
     
    </div>
    <div *ngIf="apiKeyCreated">
        <p class="form-subheading">API Key generated successfully!</p>
        <span class="extra-text">Please copy and save the generated API Key below. Once this modal is closed, It won't be displayed again.</span>
        <app-copy-text [text]="this.generatedApiKey"></app-copy-text>
        <!-- <div class="button"><app-button-outline [action]="closeModal"  buttonText="Close Modal"></app-button-outline></div> -->
    </div>

  </app-modal>
  <app-modal [title]="modalTitle2" [isOpen]="isModalOpen2" (closeModalEvent)="closeModal2()">
    <p class="modal-text">Do you want to delete this API Key?</p>
    <div class="button"><app-button-fill [processLoading]="processLoading" [action]="deleteApi" buttonText="Delete"></app-button-fill></div>
        <!-- <div class="button"><app-button-outline [action]="closeModal2" buttonText="Close"></app-button-outline></div> -->

  </app-modal>
